module.exports = __webpack_public_path__ + "static/media/Dong_song_icon.c5361454.png";